export const fs = "fs-18";